<!-- 
  顶部组件
 -->
 <template>
  <div class="nav_header">
    <div class="nav_header_top">
      <div class="ys_content">
        <span @click="navTo('/manager/index/index','',true)">管理后台</span>
        <div class="nav_header_topList ys_scrollbar">
          <span class="nav_header_topItem" @click="navTo('/manager/order/orderList','',true)">我的订单</span>
          <span class="nav_header_topItem" @click="navTo('/cart')">
            <i class="icon-gouwuche-fill"></i>购物车
          </span>
          <span class="nav_header_topItem" @click="navTo('/manager/goodsNew/goodsList','',true)">
            <i class="icon-shangpin2"></i>选品库</span>
          <span class="nav_header_topItem" style="color: var(--theme-color);" @click="navTo('/index')">选品中心</span>
          <span class="nav_header_topItem" @click="navTo('/choice/v2/','',true)">返回老版</span>
          <span class="nav_header_topItem">服务热线：18973183401</span>
        </div>
      </div>
    </div>
    <div class="ys_content">
      <div class="nav_header_middle">
        <div class="nav_header_left">
          <img class="nav_header_logo" src="@/static/logo.png" @click="select('/index')">
          <div class="nav_header_logoTips">
            <div class="nav_header_logoTipItem"><span class="nav_header_icon">正</span>正品行货</div>
            <div class="nav_header_logoTipItem"><span class="nav_header_icon">底</span>底价供货</div>
            <div class="nav_header_logoTipItem"><span class="nav_header_icon">全</span>品类齐全</div>
          </div>
        </div>

        <div class="film_nav">
          
          <el-menu :default-active="$route.path.split('/')[1]" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="city" class="onenav">
              <div @click.stop="" v-on:mouseover="cityShow=true" v-on:mouseout="cityShow=false">
                <div class="fl">{{citySelect.city_name||'所在城市'}}</div><i class="el-icon-arrow-down"></i>
                <div class="city" v-show="cityShow">
                    <div class="city_search">
                      <el-input placeholder="请输入搜索关键词" v-model="letterVal" class="input-with-select">
                        <el-button type="danger" slot="append" icon="el-icon-search"></el-button>
                      </el-input>
                    </div>
                    <div class="city_header ys_scrollbar">
                        <div class="city_header_item" v-for="(item,index) in letter" :key="index" @click="onSelectLetter(item)">{{item}}</div>
                    </div>
                    <!-- <div class="city_recently">
                        最近使用
                        <span>长沙&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <span>长沙&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <span>长沙&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    </div> -->
                    <div class="city_list ys_scrollbar" ref="cityList">
                      <div class="city_item" v-for="(item,index) in cityList" :key="index" v-show="!item.hide"  ref="cityItem">
                          <div class="city_item_left">{{item.city_name}}</div>
                          <div class="city_item_right">
                            <div class="text" v-show="!row.hide"
                            :class="{active:citySelect.city_sign==row.city_sign}" 
                            @click="cityChange(row)"
                            v-for="(row,key) in item.city" :key="key" >{{row.city_name}}</div>
                          </div>
                      </div>
                      <el-empty description="抱歉，未查找到地区~" v-if="notData"></el-empty>
                    </div>
                </div>
              </div>
            </el-menu-item>
            <!-- <el-select v-model="citySelect" class="header-city" filterable placeholder="所在城市" @change="cityChange">
              <el-option
                v-for="(item,index) in cityList"
                :key="index"
                :label="item.city_name"
                :value="item.city_sign">
              </el-option>
            </el-select> -->
            <el-menu-item index="filmclient" @click="select('/filmclient')">电影</el-menu-item>
            <!-- <el-menu-item index="cinemalist" @click="select('/cinemalist')">影院</el-menu-item> -->
            <el-menu-item style="width:48%;border-bottom:none">
              <div class="search">
                  <el-input class="search_input" :placeholder="`请输入${$route.name=='cinemalist'?'影院':'电影'}名称`" v-model="searchText" clearable @clear="onSearchBind(true)" @keyup.native.enter="onSearchBind()">
                    <el-button slot="append" icon="el-icon-search" v-waves @click="onSearchBind()">搜索</el-button>
                  </el-input>
              </div>
            </el-menu-item>
            <div class="phone_buy">
              <!-- <el-popover placement="top-start" popper-class="phone_pop" title="" width="80" trigger="hover">
                <img src="../../img/sjewm.jpg" style="display: block;margin: 0 auto 10px;"/>
                <el-link :underline="false" slot="reference">手机购买&nbsp;&nbsp;<i class="el-icon-caret-bottom"></i></el-link>
                <div style="text-align: center;">手机购票更方便</div>
              </el-popover> -->
              <el-button type="danger" @click="select('/index')">返回首页</el-button>
            </div>
          </el-menu>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getCity } from '../../js/api'
import { mapActions,mapState } from 'vuex'

  export default {
    name: 'filmHeader',
    data() {
      return {
        citySelect : {},
        cityShow : false,
        activeIndex: '2',
        cityList:[],
        letter : [],
        letterVal : null,
        letterSted : '',
        notData : false,
        searchText : ''
      }
    },
    watch: {
      letterVal(newVal,oldVal){
          this.letter = [];
          this.notData  = true;
          this.cityList.map(item=>{
            item.hide = true;
            item.city.forEach((row,key)=>{
              if(newVal&&row.city_name.includes(newVal)==false){
                item.city[key].hide = true;
              }else{
                item.city[key].hide = false;
                item.hide = false;
                if(!this.letter.includes(item.initial)){
                  this.letter.push(item.initial);
                }
                this.notData  = false;
              }
            })
            return item;
          })
      }
    },
    computed:{
      ...mapState(['sysInfo']),
      ...mapState(['film'])
    },
    filters: {

    },
    mounted() {
      this.init();
      // this.getSystemConfig();
    },
    methods: {
      ...mapActions(['getSystemConfig','setState']),
      init() {
        //获取所在城市
        getCity({page:1,limit:100}).then(res=>{
          if (res.code == 200) {
            this.cityList = res.data.list;
            this.citySelect = this.film.citySelect||res.data.list[0].city[0];
            this.letterVal  = '';
            if(!this.film.citySelect){
              this.cityChange(this.citySelect);
            }
          }
        })
      },
      cityChange(sign){
        this.setLocal('citySelect',sign)
        this.citySelect = sign;
        this.cityShow = false;
        this.film.citySelect = sign;
        this.setState({
          film: this.film
        })
        let path = this.$route.path=='/cinemalist' ? this.$route.path : '/filmclient';
        this.navTo(path, {reset:1}, false)
      },
      handleSelect(key, keyPath) {
      },
      /**
       * 选择
       * */
       select(path) {
          this.searchText = '';
          this.navTo(path, {reset:1},false)
      },
      onSelectLetter(item){
        document.querySelector('.city_list').scrollTo({
            top: this.$refs.cityItem[this.cityList.findIndex(i=>i.initial==item)].offsetTop-120,
            behavior: 'smooth',
          });
        this.letterSted = item;
      },
      onSearchBind(isClear){
        if(isClear){
          this.searchText = '';
        }else if(!this.searchText){
          return this.$message.warning('请输入电影名称')
        }
        if(this.$route.path!='/filmclient'&&this.$route.path!='/cinemalist'){
          this.$router.push({name:'filmclient',params:{film_name:this.searchText}})
        }else{
          this.$bus.$emit('filmSearch',this.searchText)
          this.$bus.$emit('filmMainScrollTo')
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .nav_header {

    .film_nav{
      width: 100%;
      font-size: 18px;

      

      .phone_buy{
        float: right;
        height: 40px;
        line-height: 40px;
        position: relative;
        text-align: center;
        .el-link.el-link--default{
          font-size: 18px;
          color: #333;
        }
      }
    }

    .el-popover.phone_pop{
      min-width: 82px;
    }
    


    .nav_header_middle{
      padding-bottom: 20px;
    }

    width: 100%;
    background-color: #fff;
    border-bottom: 1px solid #e6e6e6;
    --navItem-first: 200px;

    // 顶部
    &_top {
      height: 32px;
      line-height: 24px;
      font-size: 12px;
      color: #666;
      background-color: #F0F0F0;

      .ys_content {
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      span {
        flex-shrink: 0;
        cursor: pointer;
        user-select: none;
      }
    }

    &_topList {
      height: 100%;
      display: flex;
      align-items: center;
      overflow-x: auto;
    }

    &_topItem {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      padding: 0 15px;
      white-space: nowrap;
      position: relative;
      margin: 0 10px;

      &~&::before {
        content: '';
        position: absolute;
        left: -10px;
        top: 50%;
        width: 1px;
        height: 8px;
        margin-top: -4px;
        background-color: #ccc;
      }

      [class^=el-icon-],
      [class^=icon-] {
        font-size: 15px;
        color: var(--theme-color);
        margin-right: 4px;
      }

      &:not(:last-child):hover {
        background-color: #ccc;
        border-radius: 4px;
      }

      &:last-child {
        cursor: default;
        user-select: text;
      }
    }

    // 中间部分 搜索
    &_middle {
      display: flex;
      padding-top: 12px;
    }

    &_left {
      flex-shrink: 0;
      width: 308px;
    }

    &_logo {
      display: block;
      width: 200px;
      cursor: pointer;
    }

    &_logoTips {
      display: flex;
      align-items: center;
      margin-top: 12px;
    }

    &_logoTipItem {
      display: flex;
      align-items: center;
      height: 24px;
      font-size: 12px;
      color: #999;
      padding-left: 26px;
      position: relative;
      // background: url('~@/static/header-tip1.png') 0 center no-repeat;
      // background-size: 19px auto;

      // &:nth-child(2) {
      //   background-image: url('~@/static/header-tip2.png');
      // }

      // &:nth-child(3) {
      //   background-image: url('~@/static/header-tip3.png');
      // }

      &~& {
        margin-left: 15px;
      }
    }

    &_icon{
      position: absolute;
      left: 0;
      top: 0;
      font-size: 12px;
      color:var(--theme-color);
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      border: 1px solid var(--theme-color);
      border-radius: 50%;
      transform: scale(0.8);
    }


    
  }
  .search{
    &_input {
      height: 40px;
      border-color: var(--theme-color);

      ::v-deep input {
        font-size: 14px;
        color: #333;
        height: 40px;
        line-height: 40px;
        border-color: var(--theme-color);

        &::-webkit-input-placeholder {
          font-size: 14px;
          color: #666;
        }
      }

      ::v-deep {
        .el-input-group__prepend{
          color: #fff;
          border-color: var(--theme-color);
          background-color: #fff;
        }
        .el-select{
          width: 110px;
          color: #999;
        }
        .el-input-group__append {
          padding: 0;
          color: #fff;
          border-color: var(--theme-color);
          background-color: var(--theme-color);
        }
        .el-button {
          height: 100%;
          margin: 0;
          border: none;
          color: #fff;
          background-color: var(--theme-color);
        }
        .el-icon-search{color: #fff;}
      }
    }
  }
  

  ::v-deep {
    .el-popover.phone_pop{
      min-width: 82px;
    }
    .header-city{
      float: left;
      width: 100px;
      .el-input--small .el-input__inner{
        border:none;
        line-height: 40px;
        height: 40px;
        font-size: 18px;
      }
    }
  }
  

  @media (min-width:1440px) {
    .nav_header_childCon {
      width: calc(1720px - var(--navItem-first));
    }
  }

  @media (max-width: $mediaWidth) {
    .nav_header_childCon {
      width: calc(998px - var(--navItem-first));
    }
    .nav_header_navItem:not(.nav_header_navItem_first){
      width: 99px;
    }
  }

  .onenav:hover .city{
      display: block;
  }
  .city{
      background: #fff;
      width: 600px;
      position: absolute;
      z-index: 4;
      box-shadow: 0 10px 10px 5px #0000002e;
      font-size: 16px;
      &_search{
        padding: 20px 40px;
        border-bottom: 1px solid #f1f1f1;
      }
      &_header{
        overflow-x: auto;
        text-transform: uppercase;
        width: calc(100% - 45px);
        border-bottom: 1px solid #eee;
        margin: 0 15px 0 30px;
        
        &_item{
          width: 2rem;
          line-height: 2rem;
          text-align: center;
          display: inline-block;
          border-radius: 4px;
          &:hover{
            background-color: var(--theme-color);
            color: #fff;
          }
        }
      }
      &_list{
        max-height: 400px;
        overflow:auto;
        margin: 0 0 10px 20px;
        /* 设置滚动条的样式 */
        &::-webkit-scrollbar {
          width: 4px;
          height: 4px;
          border-radius: 4px;
          background-color: rgba(0, 0, 0, 0.1);
        }
        // /* 滚动条滑块 */
        &::-webkit-scrollbar-thumb {
          width: 2px;
          border-radius: 4px;
          background: rgba(0, 0, 0, 0.2);
        }
      }
      &_item{
        display: flex;
        font-size: 14px;
        line-height: 2rem;
        &_left{
          // width: 10%;
          text-align: center;
          margin-right: 15px;
          color: #777;
          width: 60px;
          white-space: normal;
          line-height: normal;
          padding: 6px 0;
          cursor: auto;
        }
        &_right{
          display: flex;
          flex-flow: wrap;
          width: calc(100% - 60px);
          &_item{
          }
          .text{
            display: inline-block;
            text-align: center;
            margin-right: 15px;
            &:last-child{
              margin-right: 0;
            }
            &:hover,&.active{
              color: var(--theme-color);
              transform: scale(1.05);
              font-weight: 600;
            }
          }
        }
        &:last-child{
          margin-bottom: 80px;
        }
        &:first-child{
          margin-top: 10px;
        }
      }
  }
  .fl{
    float: left;
  }
</style>